import React from "react";

import { useContentContext } from "../../context/content-context";

const GradientCta = () => {
  const { hcpCTA } = useContentContext();

  if (hcpCTA) {
    const { text, buttonText, buttonUrl } = hcpCTA;

    if (text) {
      return (
        <section className="section-outer hcp">
          <div className="section-inner">
            <div className="gradient-cta m-0-auto">
              <p
                role="heading"
                aria-level="4"
                className="white mb-20 xlarge strong sentence-case"
                dangerouslySetInnerHTML={{ __html: text }}
              />
              <a className="button solid-teal fixed-width" href={buttonUrl}>
                {buttonText}
              </a>
            </div>
          </div>
        </section>
      );
    }
  }

  return null;
};

export default GradientCta;
